import ua from './platform'
import store from '@/store'
import { Dialog } from 'vant'

// 挂载到window对象，供app端调用以注入token
export function fs_main(token) {
  store.state.isApp = true
  store.commit('setToken', token)
}

// 登录
export function fs_login() {
  if (ua.isAndroid && window.ZMBridge) {
    window.ZMBridge.login()
  } else if (ua.isIOS && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.login) {
    window.webkit.messageHandlers.login.postMessage(0)
  }
}

// 获取用户信息
export function fs_getUserInfo() {
  return new Promise((resolve) => {
    if (ua.isAndroid && window.ZMBridge) {
      window.ZMBridge.getUserinfo()
    } else if (ua.isIOS && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getUserinfo) {
      window.webkit.messageHandlers.getUserinfo.postMessage(0)
    }
    setTimeout(() => {
      resolve()
    }, 100)
  })
}

// 分享
export function appShare(title, desc, url) {
  let img = 'https://content.foshanplus.com/foshanlogo.png'
  let shareType = 0
  if (ua.isAndroid && window.ZMBridge) {
    window.ZMBridge.share(title, desc, url, img, shareType)
  } else if (ua.isIOS && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
    window.webkit.messageHandlers.share.postMessage({
      title,
      desc,
      url,
      img,
      shareType
    })
  }
}

/**
 * app页面内跳转路由
 * @param {*} route
 */
export function gotByRoute(route) {
  if (ua.isAndroid && window.ZMBridge) {
    window.ZMBridge.gotByRoute(route)
  } else if (ua.isIOS && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.gotByRoute) {
    window.webkit.messageHandlers.gotByRoute.postMessage({
      route
    })
  }
}

/**
 * 关闭webview页面
 */
export function closeWebView() {
  if (ua.isAndroid && window.ZMBridge) {
    window.ZMBridge.closeWebView()
  } else if (ua.isIOS && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.closeWebView) {
    window.webkit.messageHandlers.closeWebView.postMessage(0)
  }
}

// 跳到首页
export function goToMainPage() {
  if (ua.isAndroid && window.ZMBridge) {
    window.ZMBridge.goToMainPage()
  } else if (ua.isIOS && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.goToMainPage) {
    window.webkit.messageHandlers.goToMainPage.postMessage(0)
  }
}

// 授权后操作
export function auth() {
  return new Promise((resolve) => {
    if (store.state.token && store.state.token.length > 0) {
      resolve()
    } else {
      if (store.state.isApp) {
        fs_login()
      } else {
        resolve()
      }
    }
  })
}

export function logout() {
  if (ua.isAndroid && window.ZMBridge && window.ZMBridge.logout) {
    window.ZMBridge.logout(0)
  } else if (ua.isIOS && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.logout) {
    window.webkit.messageHandlers.logout.postMessage(0)
  } else {
    if (store.state.isApp) {
      Dialog.alert({ title: '提示', message: '登录失效，请重新登陆后尝试。进入佛山+APP首页，点击右上角我的，再点击右上角设置，点击退出登录后重新登陆即可。' })
    }
    return false
  }
  return true
}
